import React, { Component } from 'react';
import { injectIntl, defineMessages } from 'react-intl';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';

import { Image, Dropdown } from 'semantic-ui-react';
import { Tooltip } from 'material-ui';

import classNames from 'classnames/bind';
import styles from './Declare.css';
const cx = classNames.bind(styles);

class DeclareExamFilter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: true
    };
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    // const { handleTooltipOpen, handleTooltipClose } = this;
    const { examNoArray, declareExamOrdering, handleSelectOptions, currentPath } = this.props;

    let text = defineMessages(formatMessage({ id: 'ExamHeader_4', defaultMessage: '전체 훈련' }));

    const declareExamOption = [
      <div key="all" className={cx('default-item-line')}>
        <Dropdown.Item
          title={defineMessages(formatMessage({ id: 'ExamHeader_4', defaultMessage: '전체 훈련' }))}
          key="all"
          value="all"
          className={cx({ selected: examNoArray.indexOf('all') !== -1 })}
          onClick={(e, props) => {
            // e.stopPropagation();
            handleSelectOptions(e, props);
          }}>
          <div className={cx('box-text')}>
            {defineMessages(formatMessage({ id: 'ExamHeader_4', defaultMessage: '전체 훈련' }))}
          </div>
        </Dropdown.Item>
      </div>
    ];

    declareExamOrdering.map((examNo, index) => {
      const { declareExamByExamNo } = this.props;
      const data = declareExamByExamNo.get(String(examNo));

      declareExamOption.push(
        <Dropdown.Item
          title={data.get('examName')}
          key={examNo}
          value={data.get('examNo')}
          className={cx({ selected: examNoArray.indexOf(data.get('examNo')) !== -1 })}
          onClick={(e, props) => {
            // e.stopPropagation();
            handleSelectOptions(e, props);
          }}>
          <div className={cx('box-text')}>{data.get('examName')}</div>
        </Dropdown.Item>
      );

      if (examNoArray.indexOf(data.get('examNo')) !== -1) {
        text = data.get('examName');
      }
    });

    return ( 
      <div className={cx('react-search')}>
        <Tooltip title={text} placement="right">
          <div className={cx('seacrch-input-area')}>
            <div className={cx('search-dropdown-area')}>
              <div className={cx('dropdown-arrow-area')}>
                <Image className={cx('pageSize-dropdown-image')} src="/img/table/selectbox_number_arrow.png" />
              </div>
              <Dropdown
                text={text}
                pointing
                scrolling
                icon={null}
                defaultValue={'all'}
                className={cx('search-dropdown')}>
                <Dropdown.Menu className={cx('left')}>{declareExamOption}</Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </Tooltip>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  declareExamByExamNo: state.declare.get('declareExamByExamNo'),
  declareExamOrdering: state.declare.get('declareExamOrdering'),
  examNoArray: state.declare.get('examNoArray'),
  currentPath: state.currentStatus.getIn(['path', 'current'])
});

export default connect(mapStateToProps)(injectIntl(DeclareExamFilter));



// WEBPACK FOOTER //
// ./src/script/components/declare/DeclareExamFilter.js